import { render } from "./header_title.vue?vue&type=template&id=6bae50ff&scoped=true"
import script from "./header_title.vue?vue&type=script&lang=js"
export * from "./header_title.vue?vue&type=script&lang=js"

import "./header_title.vue?vue&type=style&index=0&id=6bae50ff&scoped=true&lang=css"

import exportComponent from "/home/kabull/js/vue/iqtest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bae50ff"]])

export default __exports__